import React from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import PromotionHelper from "../../../../services/Menu/services/Promotion/PromotionHelper";
import Utils from "../../../../utils/Utils";
import Money from "../../../../components/Common/Money";
import AppConfig from "../../../../services/AppConfig";
import {ReactComponent as MenuItemDarkIco} from "../../../../../images/icons/menus/menu-item-dark.svg";
import {ReactComponent as MenuItemIco} from "../../../../../images/icons/menus/menu-item.svg";
import {ReactComponent as PlusIco} from "../../../../../images/icons/plus.svg";
import RoundedIcon from "../../../../components/Common/RoundedIcon";
import AvailableHelper from "../../../../services/Menu/services/Availability/AvailableHelper";
import HoursHelper from "../../../../services/Menu/services/Availability/HoursHelper";
import DateService from "../../../../services/Common/Date/DateService";
import {connect} from "react-redux";
import {RootState} from "../../../../../reducers";
import {getAvailabilities, getMenus} from "../../../../services/Menu/reducer";
import {getSession, selectLocale} from "../../../../services/Session/reducer";
import {MenuProductViewType, OrderType} from "../../../../services/Api/types";
import MenuCategoryProductAvailabilityInfo from "./MenuCategoryProductAvailabilityInfo";
import {getStoreConfig} from "../../../../services/Store/reducer";

interface OwnProps {
    addItem: (id: number) => void;
    product: any;
    promotions: any[];
    forceNotAvailable?: true;
    viewType: MenuProductViewType;
    category: any;
    itemsExpanded?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MenuCategoryProduct = ({
                                 addItem,
                                 product,
                                 promotions,
                                 availabilities,
                                 session,
                                 locale,
                                 forceNotAvailable,
                                 viewType,
                                 config,
                                 category,
                                 menus,
                                 itemsExpanded
                             }: Props) => {
    const {t} = useTranslation();
    let item = JSON.parse(JSON.stringify(product));
    let itemName = item.name;
    let itemDisabled = item.disabled;

    if (product.type && product.type === "ITEM_GROUP") {
        item = product.item;
        itemName = product.name;
        itemDisabled = product.disabled !== undefined ? product.disabled : false;
    }

    const availability = AvailableHelper.getAvailability(availabilities, item.availability_id);
    const isOpen = availability ? HoursHelper.isOpen(availability.hours, DateService.emptyOrNow(session.pickup_at)) && AvailableHelper.isAvailabile(availability, DateService.emptyOrNow(session.pickup_at)) : true;
    const isAvailable = isOpen && !itemDisabled;
    const orderType = session.order_type as OrderType;

    const handleAddItem = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
        event.preventDefault();

        addItem(item.id);
    }

    const renderDescription = () => {
        if (item.description) return item.description;

        if (!item.selected_items || item.selected_items.length <= 0) {
            return null;
        }

        const descriptions: string[] = [];
        item.selected_items.forEach(function (selectedItem: any) {
            descriptions.push(selectedItem.quantity > 1 ? selectedItem.quantity + "x" + selectedItem.translation.name : selectedItem.translation.name);
        });

        return descriptions.join(", ");
    }

    const renderTags = () => {
        const itemPromotions = PromotionHelper.getForItem(promotions, item.id);

        if (!itemPromotions || itemPromotions.length <= 0) return null;

        if (viewType === MenuProductViewType.HORIZONTAL) {
            const tags = itemPromotions.map((promotion: any) => promotion.name).join(", ");

            return (
                <span className="badge badge-success-light tag">{tags}</span>
            )
        }

        return (
            <div className={"tags"}>
                {itemPromotions.map((promotion: any) => (
                    <span key={promotion.id} className="badge badge-success-light">{promotion.name}</span>
                ))}
            </div>
        )
    }

    const drawPrice = () => {
        return (
            item.discount_price ? (
                <div className="prices price-bottom">
                    <span className="price price-discount">
                        <Money value={item.price} currency='PLN'/>
                    </span>
                    <span className="price text-danger">
                        <Money value={item.discount_price} currency='PLN'/>
                    </span>
                </div>
            ) : (item.price && item.price > 0) ? (
                <span className="price price-bottom">
                    <Money value={item.price} currency='PLN'/>
                </span>
            ) : null
        );
    }

    const getItemAvailabilityClassName = () => {
        if (!item.image_link) return "menu-item-not-available with-colors";

        return "menu-item-not-available";
    }

    const getItemClassNameBasedOnAvailability = () => {
        if (viewType === MenuProductViewType.HORIZONTAL) {
            if (forceNotAvailable) {
                return `menu-item-not-available`;
            }
        } else {
            if (forceNotAvailable) {
                return `menu-item-not-available ${!itemsExpanded || !item.image_link ? 'with-colors' : ''}`;
            }
        }

        return isAvailable ? "" : getItemAvailabilityClassName();
    }

    return (
        <a href="#" className={`menu-item ${getItemClassNameBasedOnAvailability()}`}
           onClick={(event) => handleAddItem(event)}>
            <div className="card">
                <div className="card-img">
                    <div>
                        {
                            item.image_link ? <img src={item.image_link.small}
                                                   alt={t("common.word.product_image")}/> : AppConfig.isDarkMode() ?
                                <MenuItemDarkIco/> : <MenuItemIco/>
                        }
                        <RoundedIcon size="small" icon={<PlusIco/>} className="text-primary"/>
                    </div>
                    {viewType === MenuProductViewType.HORIZONTAL && (
                        <>
                            {renderTags()}
                            <MenuCategoryProductAvailabilityInfo availability={availability}
                                                                 isAvailable={isAvailable}
                                                                 locale={locale} forceNotAvailable={forceNotAvailable}
                                                                 item={item} orderType={orderType} menus={menus}
                                                                 pickupDate={session.pickup_at} config={config}
                                                                 category={category} availabilities={availabilities}
                                                                 viewType={viewType}/>
                        </>
                    )}
                </div>
                <div className="card-body">
                    {
                        viewType === MenuProductViewType.VERTICAL ? (
                            <>
                                <MenuCategoryProductAvailabilityInfo availability={availability}
                                                                     isAvailable={isAvailable}
                                                                     locale={locale}
                                                                     forceNotAvailable={forceNotAvailable}
                                                                     item={item} orderType={orderType}
                                                                     pickupDate={session.pickup_at}
                                                                     config={config}
                                                                     category={category}
                                                                     menus={menus}
                                                                     availabilities={availabilities}
                                                                     viewType={viewType}/>
                                <h1 className="card-title">{itemName}</h1>
                            </>
                        ) : (
                            <>
                                {drawPrice()}
                                <h1 className="card-title">{itemName}</h1>
                            </>
                        )
                    }
                    <p className="card-text"
                       dangerouslySetInnerHTML={{__html: Utils.nl2brString(renderDescription())}}/>
                    {
                        viewType === MenuProductViewType.VERTICAL && (
                            <>
                                {renderTags()}
                                {drawPrice()}
                            </>
                        )
                    }
                </div>
            </div>
        </a>
    )
}

const mapStateToProps = (state: RootState) => ({
    availabilities: getAvailabilities(state.menu),
    session: getSession(state.session),
    locale: selectLocale(state.session),
    config: getStoreConfig(state.config),
    menus: getMenus(state.menu),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuCategoryProduct));
